import React, { Component } from "react";
import classNames from "classnames";
import _, { without } from "lodash";
import { decorators } from "@orange-marmalade/paginate-this";
import PropTypes from "prop-types";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import { Authorized, DataTable } from "MODULES/shared/components";
import {
  CAN_ADD_COMPANIES,
  CAN_UPDATE_COMPANIES,
  ROLES,
  WAREHOUSE
} from "MODULES/users/constants";
import Controls from "./Controls";
import AddContact from "./Create/AddContact";
import EditContact from "./Edit/EditContact";

function renderRow(contact, openEditForm) {
  const handleMailto = e => {
    e.stopPropagation();
  };
  const classes = classNames("clickable", { "text-muted": !contact.active });

  return (
    <tr
      key={contact.id}
      className={classes}
      onClick={() => openEditForm(contact)}
    >
      <td>{contact.title}</td>
      <td>{contact.name}</td>
      <td>
        <a href={`mailto:${contact.email}`} onClick={handleMailto}>
          {contact.email}
        </a>
      </td>
      <td>{contact.position}</td>
      <td>{contact.phone1}</td>
      <td>{contact.phone2}</td>
      <td>{contact.phone3}</td>
      <td className="text-center">
        {contact.promotion_ok && <i className="text-success fa fa-check" />}
      </td>
      <td className="text-center">
        {contact.primary && <i className="text-success fa fa-check" />}
      </td>
      <td className="text-center">
        {contact.exchange_manager && <i className="text-success fa fa-check" />}
      </td>
      <td className="text-center">
        {contact.active && <i className="text-success fa fa-check" />}
      </td>
      <NoteTooltipTableCell note={contact.notes} />
      <td className="text-center td-shrink-icon">
        <Controls contact={contact} />
      </td>
    </tr>
  );
}

export class Contacts extends Component {
  state = {
    editFormOpen: false,
    selectedContact: {},
    isExpanded: false
  };

  openEditForm = contact =>
    this.setState({ editFormOpen: true, selectedContact: contact });

  closeEditForm = () => this.setState({ editFormOpen: false });

  toggleExpand = () => {
    this.setState(prevState => ({ isExpanded: !prevState.isExpanded }));
  };

  render() {
    const { selectedContact, editFormOpen, isExpanded } = this.state;
    const { results, isLoading } = this.props;
    const sortedResults = _.orderBy(
      results,
      ["primary", "active", "name"],
      ["desc", "desc", "asc"]
    );

    const contactsToRender = isExpanded
      ? sortedResults
      : sortedResults.slice(0, 8);

    return (
      <div>
        <h2>
          Contacts
          <Authorized
            roles={without(ROLES, WAREHOUSE)}
            permissions={[CAN_ADD_COMPANIES, CAN_UPDATE_COMPANIES]}
          >
            <AddContact />
            <EditContact
              open={editFormOpen}
              close={this.closeEditForm}
              contact={selectedContact}
            />
          </Authorized>
        </h2>

        <DataTable.Mini loading={isLoading}>
          <DataTable.Head>
            <th>Salutation</th>
            <th>Name</th>
            <th>Email</th>
            <th>Position/Title</th>
            <th>Phone #1</th>
            <th>Phone #2</th>
            <th>Phone #3</th>
            <th className="text-center">Promotions OK</th>
            <th className="text-center">Primary</th>
            <th className="text-center">Exch. Manager</th>
            <th className="text-center">Active</th>
            <th className="text-center">&nbsp;</th>
            <th className="text-center">&nbsp;</th>
          </DataTable.Head>
          <DataTable.Body>
            {contactsToRender.map(contact =>
              renderRow(contact, this.openEditForm)
            )}
          </DataTable.Body>
        </DataTable.Mini>
        {results.length > 8 && (
          <div className="expand-button-container">
            <button
              className="btn btn-primary btn-hollow"
              onClick={this.toggleExpand}
            >
              {isExpanded ? "Collapse" : "Expand"}
            </button>
          </div>
        )}
      </div>
    );
  }
}

Contacts.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      active: PropTypes.bool,
      name: PropTypes.string,
      email: PropTypes.string,
      phone1: PropTypes.string,
      phone2: PropTypes.string,
      phone3: PropTypes.string,
      position: PropTypes.string,
      primary: PropTypes.bool,
      promotion_ok: PropTypes.bool
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired
};

export const TabulateContacts = decorators.tabulate(Contacts);
export default () => <TabulateContacts listId="company/contacts" />;



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Contacts/Contacts.jsx